import { useEffect, useRef } from 'react';

/**
 * Accepts a function to run once on mount
 *
 * @param effect Imperative function that can return a cleanup function
 */
const useMount = (func: () => void) => {
  const callback = useRef(func).current;

  useEffect(() => {
    callback();
  }, [callback]);
};

export default useMount;
